import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { identifyUser, resetAnalytics } from './index';

// Bridges Redux auth state to PostHog identity. The profile is fetched globally
// (Header), so analytics_id becomes available shortly after login; identifyUser is
// idempotent and only fires when the id actually changes.
const AnalyticsIdentity = () => {
  const isAuthenticated = useSelector((state) => state.user?.isAuthenticated);
  const analyticsId = useSelector((state) => state.profile?.profile?.analytics_id);

  useEffect(() => {
    if (isAuthenticated && analyticsId) {
      identifyUser(analyticsId);
    }
  }, [isAuthenticated, analyticsId]);

  useEffect(() => {
    if (!isAuthenticated) {
      resetAnalytics();
    }
  }, [isAuthenticated]);

  return null;
};

export default AnalyticsIdentity;
